export {default as UpdateCompany} from './UpdateCompany';